import CartCountJSC from '@/schema/CartCountJSC';
import { CxJourneyAPIRequestBuilder } from '@/models/Common/CxJourneyAPIRequestBuilder';
import { TReqConfigValidated } from '../../services/JSCService';
import { ICartCountRequestParams } from './interfaces/ICartCountRequestParams';

export default class CartRequestBuilder extends CxJourneyAPIRequestBuilder {
  createGetCartCountQuery(reqParams: ICartCountRequestParams): TReqConfigValidated {
    return this.validate(CartCountJSC, reqParams).map((params) => this.makeConfig('GET', '/cart/v1/count', params));
  }
}
